import actions from './moduleHelpActions';
import getters from './moduleHelpGetters';
import mutations from './moduleHelpMutations';
import state from './moduleHelpState';

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
